import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "detail-container" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = {
  key: 1,
  class: "error-container"
}
const _hoisted_4 = {
  key: 2,
  class: "content-container"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 3,
  class: "empty-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
      class: "back-button"
    }, "返回"),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "loading-spinner" }, null, -1),
          _createElementVNode("p", null, "加载中...", -1)
        ]))]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", null, "加载失败：" + _toDisplayString(_ctx.error), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchDetailData && _ctx.fetchDetailData(...args))),
              class: "retry-button"
            }, "重试")
          ]))
        : (_ctx.validImageUrls.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validImageUrls, (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "detail-image-item"
                }, [
                  _createElementVNode("img", {
                    src: _ctx.trimImageUrl(image),
                    alt: `Detail Image ${index + 1}`
                  }, null, 8, _hoisted_5)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("p", null, "暂无数据", -1)
            ]))]))
  ]))
}